(function () {
  function init(root) {
    if (!root || root.dataset.homeInitialized === 'true') return;
    root.dataset.homeInitialized = 'true';
       const ugcVideoCards = Array.from(root.querySelectorAll('.home-ugc-video-card'));
       const ugcCarousel = root.querySelector('.home-ugc-video-carousel');
       const ugcPrev = root.querySelector('.home-ugc-video-nav--home-prev');
       const ugcNext = root.querySelector('.home-ugc-video-nav--home-next');
       const ugcVideoListeners = [];
       const ugcPendingRestarts = new Map();
       let ugcActiveIndex = Math.min(1, Math.max(0, ugcVideoCards.length - 1));

      function syncUgcNavButtons() {
        const lastIndex = ugcVideoCards.length - 1;
        [[ugcPrev, ugcActiveIndex > 0], [ugcNext, ugcActiveIndex < lastIndex]].forEach(([button, isEnabled]) => {
          if (!button) return;
          button.disabled = !isEnabled;
          button.setAttribute('aria-disabled', isEnabled ? 'false' : 'true');
        });
      }

       function resetUgcVideo(video) {
         const pendingRestart = ugcPendingRestarts.get(video);
         if (pendingRestart) {
           video.removeEventListener('loadedmetadata', pendingRestart);
           ugcPendingRestarts.delete(video);
         }
         video.pause();
         try {
           video.currentTime = 0;
        } catch (error) {
          // The video metadata may not be available yet.
        }
         syncUgcPlayControl(video);
       }

       function restartUgcVideo(video, withAudio) {
         resetUgcVideo(video);
         video.muted = !withAudio;
         video.defaultMuted = !withAudio;

         const startPlayback = () => {
           ugcPendingRestarts.delete(video);
           video.pause();
           try {
             video.currentTime = 0;
           } catch (error) {
             // The video metadata may not be available yet.
           }
           video.play().catch(() => {
             if (!withAudio) return;
             // Keep the user action useful when the browser declines audible playback.
             video.muted = true;
             video.defaultMuted = true;
             video.play().catch(() => {});
           });
           syncUgcPlayControl(video);
         };

         if (video.readyState >= HTMLMediaElement.HAVE_METADATA) {
           startPlayback();
           return;
         }

         const onLoadedMetadata = () => startPlayback();
         ugcPendingRestarts.set(video, onLoadedMetadata);
         video.addEventListener('loadedmetadata', onLoadedMetadata, { once: true });
       }

      function syncUgcPlayControl(video) {
         const control = video.closest('.home-ugc-video-card')?.querySelector('.home-ugc-play');
         if (!control) return;
         const isPlaying = !video.paused && !video.ended;
         control.hidden = isPlaying;
         control.textContent = isPlaying ? '' : '▶';
         control.setAttribute('aria-label', 'Reproducir experiencia con sonido');
         control.setAttribute('aria-pressed', 'false');
         control.setAttribute('aria-hidden', isPlaying ? 'true' : 'false');
         control.tabIndex = isPlaying ? -1 : 0;
      }

      function bindUgcVideoEvents(video) {
        const syncControl = () => syncUgcPlayControl(video);
        ['play', 'playing', 'pause', 'ended', 'volumechange'].forEach((eventName) => video.addEventListener(eventName, syncControl));
        const setReady = () => video.closest('.home-ugc-video-card')?.classList.add('home-video-ready');
        const setUnavailable = () => video.closest('.home-ugc-video-card')?.classList.remove('home-video-ready');
        ['loadeddata', 'canplay', 'playing'].forEach((eventName) => video.addEventListener(eventName, setReady));
        ['error', 'stalled'].forEach((eventName) => video.addEventListener(eventName, setUnavailable));
        ugcVideoListeners.push({ video, syncControl, setReady, setUnavailable });
        if (video.readyState >= HTMLMediaElement.HAVE_CURRENT_DATA) setReady();
        syncControl();
      }

      function playUgcVideo(video, withAudio) {
        if (withAudio) {
          video.muted = false;
          video.defaultMuted = false;
        }

        video.play().catch(() => {
          if (!withAudio) return;
          // Keep the user action useful when the browser declines audible playback.
          video.muted = true;
          video.defaultMuted = true;
          video.play().catch(() => {});
        });
        syncUgcPlayControl(video);
      }

      function syncUgcVideos() {
        ugcVideoCards.forEach((card, index) => {
          card.querySelectorAll('video').forEach((video) => {
            video.muted = true;
            video.defaultMuted = true;
            if (index === ugcActiveIndex) {
              playUgcVideo(video, false);
            } else {
              resetUgcVideo(video);
            }
          });
        });
      }

      function renderUgcCarousel() {
        if (!ugcVideoCards.length) return;
        ugcVideoCards.forEach((card, index) => {
          const total = ugcVideoCards.length;
          const prevIndex = (ugcActiveIndex - 1 + total) % total;
          const nextIndex = (ugcActiveIndex + 1) % total;
          card.classList.remove('home-is-active', 'home-is-prev', 'home-is-next', 'home-is-far');
          card.setAttribute('aria-current', index === ugcActiveIndex ? 'true' : 'false');
          if (index === ugcActiveIndex) {
            card.classList.add('home-is-active');
          } else if (index === prevIndex) {
            card.classList.add('home-is-prev');
          } else if (index === nextIndex) {
            card.classList.add('home-is-next');
          } else {
            card.classList.add('home-is-far');
          }
        });
        syncUgcNavButtons();
        syncUgcVideos();
      }

      function moveUgcCarousel(direction) {
        const nextIndex = ugcActiveIndex + direction;
        if (nextIndex < 0 || nextIndex >= ugcVideoCards.length) return false;
        ugcActiveIndex = nextIndex;
        renderUgcCarousel();
        return true;
      }

      function isUgcInteractiveControl(target) {
        return Boolean(target.closest('button, a, input, select, textarea, [contenteditable="true"]'));
      }

       function activateUgcCard(index) {
         if (index !== ugcActiveIndex) {
           ugcActiveIndex = index;
           renderUgcCarousel();
         }
         ugcVideoCards[index]?.querySelectorAll('video').forEach((video) => restartUgcVideo(video, true));
       }

      function toggleUgcCard(index) {
         const videos = Array.from(ugcVideoCards[index]?.querySelectorAll('video') || []);
         const isActiveAndPlaying = index === ugcActiveIndex && videos.some((video) => !video.muted && !video.paused && !video.ended);
         if (isActiveAndPlaying) {
           videos.forEach((video) => video.pause());
           return;
         }
         if (index === ugcActiveIndex) {
           videos.forEach((video) => restartUgcVideo(video, true));
           return;
         }
         activateUgcCard(index);
      }

       ugcVideoCards.forEach((card, index) => {
         const videos = Array.from(card.querySelectorAll('video'));
         videos.forEach(bindUgcVideoEvents);
         card.addEventListener('click', (event) => {
           if (suppressUgcClick) {
             event.preventDefault();
             event.stopPropagation();
             return;
           }
           if (event.target.closest('.home-ugc-play')) return;
           if (isUgcInteractiveControl(event.target) && !event.target.closest('.home-ugc-video-select')) return;
            toggleUgcCard(index);
         });
        card.querySelector('.home-ugc-play')?.addEventListener('click', (event) => {
          event.stopPropagation();
          toggleUgcCard(index);
        });
      });

       ugcPrev?.addEventListener('click', () => moveUgcCarousel(-1));
       ugcNext?.addEventListener('click', () => moveUgcCarousel(1));
       let ugcTouchStart = null;
       let suppressUgcClick = false;
       let suppressUgcClickTimer = 0;
       const ugcSwipeThreshold = 48;
       const clearSuppressedUgcClick = () => {
         suppressUgcClick = false;
         suppressUgcClickTimer = 0;
       };
       const onUgcTouchStart = (event) => {
         const touch = event.touches[0];
         if (!touch || event.touches.length !== 1 || isUgcInteractiveControl(event.target)) {
           ugcTouchStart = null;
           return;
         }
         ugcTouchStart = { x: touch.clientX, y: touch.clientY, intent: null };
       };
       const onUgcTouchMove = (event) => {
         if (!ugcTouchStart || event.touches.length !== 1) return;
         const touch = event.touches[0];
         const horizontalDistance = touch.clientX - ugcTouchStart.x;
         const verticalDistance = touch.clientY - ugcTouchStart.y;
         if (!ugcTouchStart.intent && Math.max(Math.abs(horizontalDistance), Math.abs(verticalDistance)) > 12) {
           ugcTouchStart.intent = Math.abs(horizontalDistance) > Math.abs(verticalDistance) ? 'horizontal' : 'vertical';
         }
         if (ugcTouchStart.intent !== 'horizontal') return;
         // Page scrolling remains native until horizontal intent is confirmed.
         event.preventDefault();
       };
       const onUgcTouchEnd = (event) => {
         if (!ugcTouchStart || ugcTouchStart.intent !== 'horizontal') {
           ugcTouchStart = null;
           return;
         }
         const touch = event.changedTouches[0];
         if (!touch) {
           ugcTouchStart = null;
           return;
         }
         const horizontalDistance = touch.clientX - ugcTouchStart.x;
         ugcTouchStart = null;
         if (Math.abs(horizontalDistance) < ugcSwipeThreshold) return;
         suppressUgcClick = true;
         window.clearTimeout(suppressUgcClickTimer);
         suppressUgcClickTimer = window.setTimeout(clearSuppressedUgcClick, 400);
         moveUgcCarousel(horizontalDistance < 0 ? 1 : -1);
       };
       const onUgcTouchCancel = () => { ugcTouchStart = null; };
       ugcCarousel?.addEventListener('touchstart', onUgcTouchStart, { passive: true });
       ugcCarousel?.addEventListener('touchmove', onUgcTouchMove, { passive: false });
       ugcCarousel?.addEventListener('touchend', onUgcTouchEnd, { passive: true });
       ugcCarousel?.addEventListener('touchcancel', onUgcTouchCancel, { passive: true });
       let destroyed = false;
       root.homeCleanup = () => {
         if (destroyed) return;
         destroyed = true;
         window.clearTimeout(suppressUgcClickTimer);
         ugcCarousel?.removeEventListener('touchstart', onUgcTouchStart);
         ugcCarousel?.removeEventListener('touchmove', onUgcTouchMove);
         ugcCarousel?.removeEventListener('touchend', onUgcTouchEnd);
         ugcCarousel?.removeEventListener('touchcancel', onUgcTouchCancel);
          ugcVideoListeners.forEach(({ video, syncControl, setReady, setUnavailable }) => {
            ['play', 'playing', 'pause', 'ended', 'volumechange'].forEach((eventName) => video.removeEventListener(eventName, syncControl));
           ['loadeddata', 'canplay', 'playing'].forEach((eventName) => video.removeEventListener(eventName, setReady));
           ['error', 'stalled'].forEach((eventName) => video.removeEventListener(eventName, setUnavailable));
        });
        ugcVideoCards.forEach((card) => card.querySelectorAll('video').forEach(resetUgcVideo));
        delete root.dataset.homeInitialized;
        delete root.homeCleanup;
      };
      renderUgcCarousel();
      const revealTargets = [
        '.home-doctor-visual',
        '.home-doctor-copy > *',
        '.home-security-item'
      ];
      const revealItems = revealTargets.flatMap((selector) => Array.from(root.querySelectorAll(selector)));
      revealItems.forEach((item, index) => {
        item.classList.add('home-reveal-item');
        if (item.matches('.home-menoplay-stage, .home-menotest-visual, .home-doctor-visual, .home-cycle-panel, .home-final-cta')) {
          item.classList.add('home-reveal-scale');
        }
        item.style.setProperty('--home-reveal-delay', `${Math.min(index % 8, 6) * 70}ms`);
      });
      const sectionRevealItems = Array.from(root.querySelectorAll('.home-section-reveal'));

      if ('IntersectionObserver' in window) {
        const revealObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => { if (entry.isIntersecting) entry.target.classList.add('home-is-visible'); });
        }, { threshold: 0.16, rootMargin: '0px 0px -8% 0px' });
        const sectionRevealObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('home-is-visible');
              sectionRevealObserver.unobserve(entry.target);
            }
          });
        }, { threshold: 0, rootMargin: '0px 0px -12% 0px' });
        root.classList.add('home-reveal-motion-ready');
        window.setTimeout(() => {
          revealItems.forEach((item) => revealObserver.observe(item));
          sectionRevealItems.forEach((item) => sectionRevealObserver.observe(item));
        }, 120);
      } else {
        revealItems.forEach((item) => item.classList.add('home-is-visible'));
        sectionRevealItems.forEach((item) => item.classList.add('home-is-visible'));
      }
  }
  const currentScript = document.currentScript;
  const section = currentScript?.closest('.shopify-section');
  init(section?.querySelector('[data-home-authoritative]'));
  const handleSectionLoad = function (event) {
    init(event.target?.querySelector?.('[data-home-authoritative]'));
  };
  const handleSectionUnload = function (event) {
    const root = event.target?.querySelector?.('[data-home-authoritative]');
    root?.homeCleanup?.();
    if (root) delete root.dataset.homeInitialized;
  };
  const previousLifecycle = window.__homeTrustLifecycle;
  if (previousLifecycle) {
    document.removeEventListener('shopify:section:load', previousLifecycle.load);
    document.removeEventListener('shopify:section:unload', previousLifecycle.unload);
  }
  window.__homeTrustLifecycle = { load: handleSectionLoad, unload: handleSectionUnload };
  document.addEventListener('shopify:section:load', handleSectionLoad);
  document.addEventListener('shopify:section:unload', handleSectionUnload);
}());
